import React from "react";
import { FadeInt2Div } from "styledComponents/animation";
import DepositModule from "modules/Deposit";

const Deposit = () => {
  return (
    <>
      <FadeInt2Div>
        <DepositModule />
      </FadeInt2Div>
    </>
  );
};

export default Deposit;
